import {Timestampable} from '../../../shared/models/ressources/timestampable.model';
import {applyMixins} from 'rxjs/util/applyMixins';
import {CartInterface} from './cart.interface';
import {Delivery} from '../delivery/delivery.model';
import {LineCart} from './lineCart.model';
import {Beneficiaire} from '../beneficiaire/beneficiaire.model';

export class Cart implements CartInterface, Timestampable {
    id?: number;
    numero?: string;
    type?: string;
    panier?: boolean;
    deletable?: boolean;
    date?: Date;
    dateReference?: Date | null;
    ecritures?: Array<any> | null;
    libelle?: string | null;
    source?: string | null;
    typeAcceptation?: string | null;
    montantTrigger?: string | null;
    remarquePublic?: string | null;
    remarquePrive?: string | null;
    modeLivraison?: Delivery | null;
    statutAdministratif?: string | null;
    statusLivraison?: string | null;
    subvention?: number | null;
    lignes?: Array<LineCart> | null;
    historiqueStatuts?: Array<Object> | null;
    restantApayer?: number | null;
    datcre?: string | null;
    datmaj?: Date | null;
    usrcre?: string | null;
    usrmaj?: Date | null;
    beneficiaire?: Beneficiaire | null;
    paiementDiffereImplicite: string;
    cancelable: boolean;
    reducceCommandeNum: number;

    // Timestampable
    creeLe: Date | null;
    majLe: Date | null;
    setCreeLe: (date: string) => void;
    setMajLe: (date: string) => void;

    constructor({
                    id = null,
                    numero = null,
                    type = null,
                    panier = null,
                    deletable = null,
                    date = null,
                    ecritures = null,
                    libelle = null,
                    typeAcceptation = null,
                    montantTrigger = null,
                    remarquePublic = null,
                    remarquePrive = null,
                    modeLivraison = null,
                    statutAdministratif = null,
                    statusLivraison = null,
                    subvention = null,
                    lignes = null,
                    historiqueStatuts = null,
                    restantApayer = null,
                    datcre = null,
                    datmaj = null,
                    usrcre = null,
                    usrmaj = null,
                    paiementDiffereImplicite = '0',
                    cancelable = false,
                    reducceCommandeNum = null
                }: CartInterface) {
        this.id = id;
        this.numero = numero;
        this.type = type;
        this.panier = panier;
        this.deletable = deletable;
        this.date = date;
        this.ecritures = ecritures;
        this.libelle = libelle;
        this.typeAcceptation = typeAcceptation;
        this.montantTrigger = montantTrigger;
        this.remarquePublic = remarquePublic;
        this.remarquePrive = remarquePrive;
        this.modeLivraison = modeLivraison;
        this.statutAdministratif = statutAdministratif;
        this.statusLivraison = statusLivraison;
        this.subvention = subvention;
        this.lignes = lignes;
        this.historiqueStatuts = historiqueStatuts;
        this.restantApayer = restantApayer;
        this.datcre = datcre;
        this.datmaj = datmaj;
        this.usrcre = usrcre;
        this.usrmaj = usrmaj;
        this.paiementDiffereImplicite = paiementDiffereImplicite;
        this.cancelable = cancelable;
        this.reducceCommandeNum = reducceCommandeNum;
    }
}

applyMixins(Cart, [Timestampable]);



// WEBPACK FOOTER //
// ./src/shared/models/cart/cart.model.ts